<template>
  <div id="import-dialog" v-if="isShowLinkImport">
    <div class="">
      <el-dialog
        v-loading="loading"
        :visible.sync="isShowLinkImport"
        top="30vh"
        :center="false"
        width="360px"
        style="border-radius:15px;"
        :close-on-click-modal="true"
        :append-to-body="true"
        @close="close"
      >
        <div slot="title" class="title">链接导入</div>
        <div class="link-box">
          <el-input
            size="medium"
            placeholder="请粘贴或是输入导入文章的链接"
            v-model="link"
            @keyup.enter.native="importLink"
            class="import-link-input"
          >
          </el-input>
          <el-button class="link-button" size="small" @click="importLink"
            >导入</el-button
          >
        </div>
        <div class="explain">
          <p>
            1、请务必填写正确的文章网页链接(单个URL地址),部分链接可能出现失效的情况
          </p>
          <p>2、链接导入支持微信、知乎专栏</p>
          <p>3、导入文章后自行检查文章的完整性和排版</p>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import editorControl from "../../assets/script/utils/editorControl";
export default {
  data() {
    return {
      link: "",
      isShowLinkImport: true,
      loading: false
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    ...mapActions("api", ["ALink"]),
    //导入链接
    async importLink() {
      if (!this.link) {
        this.$message({
          showClose: true,
          message: "请粘贴或是输入导入文章的链接",
          type: "error"
        });
        return;
      }
      this.loading = true;
      var result = await this.ALink({ url: this.link });
      this.loading = false;
      if (result.errorCode != 0) {
        this.$message({
          showClose: true,
          message: result.errorMess,
          type: "error"
        });
        return;
      }
      if (this.link.indexOf("zhuanlan.zhihu.com") != -1) {
        editorControl.setAllInnerNoDataTxt(result.data, "导入文章成功");
      } else {
        editorControl.setAllInnerTxt(result.data, "导入文章成功");
      }
      this.$emit("closeShowLinkImport");
    },
    close() {
      this.$emit("closeShowLinkImport");
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/style/color";
@import "../../assets/style/config";
@import "../../assets/style/mixin";

.link-box {
  display: flex;
  width: 310px;
  .link-button {
    padding: 12px 15px;
    background-color: @blue;
    color: white;
    border-radius: 0 20px 20px 0;
    border: none;
    border-left: none;
  }
  .import-link-input /deep/.el-input__inner {
    border-radius: 20px 0 0 20px;
    border-right: none;
  }
}
//说明
.explain {
  margin-top: 10px;
  p {
    font-size: @font-size12;
    color: @color999;
    line-height: 2em;
  }
}

/deep/.el-dialog__header {
  padding: 10px !important;
  border-bottom: 1px solid #f4f4f4;
}

/deep/.el-dialog__headerbtn {
  top: 14px;
}
</style>
<style lang="less">
// .search-box .el-input__inner {
//   height: 24px;
//   line-height: 24px;

//   background-color: #568af8;
//   color: white;
//   border: none;
//   border-radius: 15px 0 0 15px;
// }
// .search-box .el-input__inner::placeholder {
//   color: #eaecfb;
// }
// .search-box .el-input--mini .el-input__icon {
//   color: #eaecfb;
// }
</style>
